// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { xBaseTheme } from "@awc/XDL/types";
import { color, getSystemColor } from "@awc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import LinkPresentationPropsDefault from "@insite/mobius/Link/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...LinkPresentationPropsDefault,
        mergeCss: true,
        color: "text.link",
        hoverStyle: {
            color: getSystemColor("common.ui8"),
        },
        typographyProps: {
            size: fontConfig.fontSize.regular,
            weight: "bold",
            css: css`
                letter-spacing: 0;
                line-height: ${fontConfig.lineHeight.singleLineRegular};
            `,
        },

        css: css`
            & ${IconWrapper} {
                transition: all 0s;
            }
            &[disabled] {
                cursor: not-allowed;
                & ${TypographyStyle} {
                    color: ${color("text.link", 0.44)};
                }
                & ${IconWrapper} {
                    opacity: 0.44;
                    color: ${color("text.link")};
                }
                &:hover {
                    ${IconWrapper} {
                        opacity: 0.44;
                        color: ${color("text.link")};
                    }
                }
            }
            &:focus-visible {
                ${IconWrapper} {
                    opacity: 0.44;
                    color: ${color("text.link")};
                }
                &:has(img) {
                    outline: 1px solid ${color("primary")};
                }
            }
        `,
    },
} as xBaseTheme["link"];
